import { Page } from '../../types'

const criminalSanctions: Page[] = [
    {
        pageType: 'question',
        title: 'Criminal Sanctions',
        name: 'criminal-sanctions',
        questions: [
            {
                questionType: 'instanceInput',
                title: 'Total number of instances',
                name: 'criminal-sanctions-total-instances',
                hint: '',
                rules: {
                    required: false
                }
            },
            {
                questionType: 'costInput',
                title: 'Estimated total value',
                name: 'criminal-sanctions-estimated-total',
                hint: '',
                rules: {
                    required: false
                }
            },    
            {
                questionType: 'textarea',
                title: 'Comments',
                name: 'criminal-sanctions-text-comments',
                hint: 'Please ensure you do not include any personal or sensitive information',
                rules: {
                    required: false
                }
            }
        ]
    },
]
export default criminalSanctions
